import React from 'react';
import { IconProps } from './typing';

const ChevronRight = ({
  iconSize = 24,
  background = 'none',
  color = '#6A767D',
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={iconSize}
    height={iconSize}
    viewBox={`0 0 ${iconSize} ${iconSize}`}
    fill={background}
  >
    <path
      d="M11.8753 8.00023C11.8753 8.30023 11.7567 8.58223 11.542 8.79289L4.87732 15.3169L4.25732 14.6836L10.9213 8.16023C11.0087 8.07356 11.0093 7.92756 10.9207 7.84023L4.25732 1.31756L4.87732 0.68356L11.5413 7.20689C11.7573 7.41823 11.8753 7.70023 11.8753 8.00023Z"
      fill={color}
    />
  </svg>
);

export default ChevronRight;
